module.exports = __webpack_public_path__ + "img/patrol.e12b2a86.svg";